/** B616 — the Insider list: the club's own email signups (marketing engine slice 1). */

import { z } from "zod";
import { EMAIL_MAX, readOp, writeOp, zEpochMs, zId } from "./common.js";

/**
 * The storefront's "Become an Insider" line (and the till's, `pos`). A
 * guest-session write — the session.guest mint plus a public-door route
 * throttle are its walls — whose answer is the UNIFORM `{}`: a new address,
 * one already on the list and one that unsubscribed read the same, so the
 * door never says who is subscribed. Checkout's opt-in is not this door: it
 * rides cart.checkout / order.buyer.set as `subscribe: true`.
 */
export const subscriberJoin = writeOp({
  name: "subscriber.join",
  permission: "order:write",
  principals: ["CUSTOMER", "RESELLER", "STAFF", "DEVICE:KIOSK"],
  fields: {
    email: z.string().email().max(EMAIL_MAX),
    source: z.enum(["storefront", "pos"]),
    channelId: zId.optional(),
  },
  response: z.object({}).strict(),
  exampleRequest: { email: "ada@example.com", source: "storefront", channelId: "web" },
  exampleResponse: {},
});

const zSubscriberRow = z
  .object({
    email: z.string().min(3),
    source: z.enum(["storefront", "checkout", "pos"]),
    consentAt: zEpochMs,
    channelId: zId.optional(),
    lastOrderAt: zEpochMs.optional(),
    confirmedAt: zEpochMs.optional(),
    unsubscribedAt: zEpochMs.optional(),
  })
  .strict();

/**
 * Settings → Audience: the tenant's list, newest consent first, each row's
 * door and dates. ADMIN-only — subscriber emails are PII, the customer.erase
 * seat (config scope both ways, the channel.config.get precedent).
 */
export const subscriberList = readOp({
  name: "subscriber.list",
  permission: "channel:write",
  principals: ["STAFF:ADMIN"],
  fields: {},
  response: z.object({ subscribers: z.array(zSubscriberRow) }).strict(),
  exampleRequest: {},
  exampleResponse: {
    subscribers: [
      { email: "ada@example.com", source: "checkout", consentAt: 1_780_000_000_000, channelId: "web", lastOrderAt: 1_780_000_000_000 },
    ],
  },
});
